import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const detailsStyle = (theme) => ({
	icon: {
		width: '100%',
		height: '100%',
		maxHeight: 84,
		color: blackColors[4],
	},
	iconCard: {
		height: 112,
		[theme.breakpoints.down('md')]: {
			maxWidth: 112,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	ebillIcon: {
		margin: '-6px 10px 0 14px',
	},
	ebill: {
		marginTop: 6,
		marginRight: 8,
	},
	cardItem: {
		marginBottom: 10,
		'& > div > div': {
			paddingTop: '36px',
		},
	},
	ebillComponentContainer: {
		marginTop: 38,
	},
	ebillComponent: {
		padding: '24px 48px',
	},
	topButton: {
		position: 'absolute',
		top: 0,
		right: 17,
		[theme.breakpoints.down('xs')]: {
			position: 'static',
		},
	},
	activateEbillIconComponent: {
		display: 'flex',
		marginTop: 19,
	},
	callIconComponent: {
		marginTop: 10,
	},
	activateEbillIcon: {
		color: blackColors[3],
		width: 18,
		height: 18,
		marginRight: 11,
	},
	headerInfo: {
		margin: 'auto 0',
	},
	center: {
		textAlign: 'center',
	},
	eBillHeader: {
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			alignItems: 'center',
			'& > div': {
				display: 'flex',
				flexDirection: 'column',
				'& > p': {
					marginBottom: 0,
				},
			},
		},
	},
	headerCardBody: {
		height: 112,
		padding: '24px',
		[theme.breakpoints.down('md')]: {
			paddingBottom: '36px',
		},
	},
	inputWrapper: {
		maxWidth: '288px',
		margin: '0 auto',
		marginBottom: '35px',
		marginTop: '24px',
	},
	accountCellWrapper: {
		'& > div': {
			justifyContent: 'flex-end',
		},
	},
	eBillHeaderWrapper: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			alignItems: 'flex-start',
		},
	},
	inlineIcon: {
		height: 16,
		width: 16,
		objectFit: 'cover',
		marginRight: 8,
	},
});

export default detailsStyle;
